import type { CSSProperties } from 'react';
import { colors, radii, shadows } from '../theme/tokens';

export const styles: Record<string, CSSProperties> = {
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '0 18px',
    background: colors.brandGreen,
    color: colors.cream,
    boxShadow: shadows.topBar,
    zIndex: 5,
    height: 56,
    position: 'relative',
  },
  logo: {
    borderRadius: radii.logo,
    objectFit: 'cover',
  },
  brandTitle: {
    fontWeight: 600,
    fontSize: 14,
  },
  brandDot: {
    opacity: 0.55,
  },
  spacer: {
    flex: 1,
  },
  liveStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
  },
  pulseDot: {
    width: 7,
    height: 7,
    borderRadius: 99,
    background: '#8FD19E',
    display: 'inline-block',
  },
  liveText: {
    fontSize: 12,
    color: 'rgba(247,244,236,.8)',
  },
  roleBadge: {
    background: 'rgba(247,244,236,.12)',
    border: '1px solid rgba(247,244,236,.28)',
    borderRadius: radii.input,
    padding: '7px 10px',
    fontSize: 12.5,
    color: colors.cream,
  },
  topBtn: {
    background: 'rgba(247,244,236,.12)',
    border: '1px solid rgba(247,244,236,.28)',
    borderRadius: radii.input,
    padding: '7px 10px',
    fontSize: 12.5,
    color: colors.cream,
    cursor: 'pointer',
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  bellBadge: {
    position: 'absolute',
    top: -4,
    right: -4,
    background: colors.danger,
    color: '#fff',
    borderRadius: radii.pill,
    fontSize: 10,
    fontWeight: 700,
    padding: '1px 5px',
    minWidth: 16,
    textAlign: 'center',
  },
  userBlock: {
    textAlign: 'right',
  },
  userNameText: {
    fontSize: 12.5,
    fontWeight: 700,
  },
  userScopeText: {
    fontSize: 10.5,
    color: 'rgba(247,244,236,.65)',
  },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid rgba(247,244,236,.35)',
    borderRadius: radii.input,
    padding: '7px 12px',
    color: colors.cream,
    fontSize: 12.5,
    cursor: 'pointer',
  },
  notifDropdown: {
    position: 'absolute',
    top: 58,
    right: 80,
    width: 380,
    maxHeight: 480,
    background: '#fff',
    borderRadius: radii.card,
    boxShadow: shadows.modal,
    border: `1px solid ${colors.borderWarm}`,
    color: colors.ink,
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  notifHeader: {
    padding: '12px 16px',
    background: colors.cream,
    borderBottom: `1px solid ${colors.borderWarm}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  notifHeaderTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: colors.brandGreen,
  },
  notifList: {
    overflowY: 'auto',
    maxHeight: 400,
    padding: 0,
    margin: 0,
    listStyle: 'none',
  },
  notifItem: {
    padding: '12px 16px',
    borderBottom: `1px solid ${colors.borderWarm}`,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  notifItemTitle: {
    fontSize: 12.5,
    fontWeight: 700,
    color: colors.ink,
  },
  notifItemMessage: {
    fontSize: 11.5,
    color: colors.muted,
    lineHeight: 1.4,
  },
  notifItemStage: {
    fontSize: 11,
    color: colors.brandGreen,
    fontWeight: 600,
  },
  notifProgressBarTrack: {
    width: '100%',
    height: 4,
    borderRadius: 2,
    background: 'rgba(0,0,0,0.06)',
    overflow: 'hidden',
    marginTop: 4,
  },
  notifActionLink: {
    marginTop: 6,
    fontSize: 11.5,
    fontWeight: 700,
    color: colors.brandGreen,
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
  },
  notifEmpty: {
    padding: 24,
    textAlign: 'center',
    color: colors.muted,
    fontSize: 12.5,
  },
};
